<template>
  <div class="feedback">
    <p class="ma-10">Function of "Feedback" will be added later.</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "feedback",
  components: {}
};
</script>
